import { StarknetWalletConnectors as StarknetWalletConnectors$1 } from '@dynamic-labs/starknet';

/* eslint-disable @typescript-eslint/no-unused-vars */
const StarknetWalletConnectors = (props) => [
    ...StarknetWalletConnectors$1(props),
];

export { StarknetWalletConnectors };
